import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=7af41f84&scoped=true&"
import script from "./tag.vue?vue&type=script&lang=js&"
export * from "./tag.vue?vue&type=script&lang=js&"
import style0 from "./tag.vue?vue&type=style&index=0&id=7af41f84&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af41f84",
  null
  
)

export default component.exports